import { render, staticRenderFns } from "./SiteAppsForgeAppAvailable.vue?vue&type=template&id=7c3256de&scoped=true&"
import script from "./SiteAppsForgeAppAvailable.vue?vue&type=script&lang=js&"
export * from "./SiteAppsForgeAppAvailable.vue?vue&type=script&lang=js&"
import style0 from "./SiteAppsForgeAppAvailable.vue?vue&type=style&index=0&id=7c3256de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3256de",
  null
  
)

export default component.exports